/* b5.js — hero sliders, application tabs, mega-menu hover images, chat button,
   product page tabs. No dependencies. Safe to load on every page. */
(function () {
  'use strict';
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  /* ---- sliders (hero main + small card slider) ---- */
  function initSlider(root, autoplay, speed) {
    var slides = root.querySelectorAll(':scope > .b5-hero__track > [data-b5-slide]');
    if (slides.length < 2) return;
    var dots = root.querySelectorAll(':scope > .b5-hero__dots [data-b5-dot]');
    var i = 0, timer = null;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function start() { if (autoplay) { stop(); timer = setInterval(function () { go(i + 1); }, speed); } }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.getAttribute('data-b5-dot')); start(); }); });
    var p = root.querySelector('[data-b5-prev]'), n = root.querySelector('[data-b5-next]');
    if (p) p.addEventListener('click', function (e) { e.preventDefault(); go(i - 1); start(); });
    if (n) n.addEventListener('click', function (e) { e.preventDefault(); go(i + 1); start(); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); start(); }
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) autoplay = false;
    start();
  }
  function initHero(scope) {
    (scope || document).querySelectorAll('[data-b5-hero]').forEach(function (hero) {
      var auto = hero.getAttribute('data-autoplay') === 'true';
      var speed = +hero.getAttribute('data-speed') || 6000;
      hero.querySelectorAll('[data-b5-slider]').forEach(function (s) {
        initSlider(s, s.hasAttribute('data-b5-mini') ? auto : auto, s.hasAttribute('data-b5-mini') ? speed + 1500 : speed);
      });
    });
  }

  /* ---- tabs (Shop by application + product page tabs) ---- */
  function initTabs(scope) {
    (scope || document).querySelectorAll('[data-b5-tabs]').forEach(function (box) {
      var tabs = box.querySelectorAll('[data-b5-tab]');
      var panels = box.querySelectorAll('[data-b5-panel]');
      function show(n) {
        tabs.forEach(function (t) { var on = t.getAttribute('data-b5-tab') === n; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
        panels.forEach(function (p) { var on = p.getAttribute('data-b5-panel') === n; p.hidden = !on; p.classList.toggle('is-active', on); });
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { show(t.getAttribute('data-b5-tab')); });
        if (window.matchMedia('(hover: hover)').matches && box.classList.contains('b5-apps')) {
          t.addEventListener('mouseenter', function () { show(t.getAttribute('data-b5-tab')); });
        }
      });
    });
  }

  /* ---- Indoor / Outdoor / Signage: swap image on hover ---- */
  function initNavMega() {
    document.querySelectorAll('[data-b5-nm]').forEach(function (nm) {
      var img = nm.querySelector('[data-b5-media-img]');
      var cap = nm.querySelector('[data-b5-media-cap]');
      var media = nm.querySelector('[data-b5-media]');
      if (!img) return;
      var defSrc = img.getAttribute('src'), defCap = cap ? cap.textContent : '', defHref = media.getAttribute('href');
      img.addEventListener('error', function () { if (defSrc && img.getAttribute('src') !== defSrc) img.src = defSrc; });
      nm.querySelectorAll('[data-b5-img]').forEach(function (a) {
        a.addEventListener('mouseenter', function () {
          nm.querySelectorAll('.is-hover').forEach(function (x) { x.classList.remove('is-hover'); });
          a.classList.add('is-hover');
          var src = a.getAttribute('data-b5-img');
          media.classList.toggle('b5-nm__media--fit', !!src && a.getAttribute('data-b5-fit') === '1');
          if (src) { img.src = src; img.hidden = false; } else if (defSrc) { img.src = defSrc; img.hidden = false; }
          /* no picture known for this item yet: read the first product / content picture from the page it links to */
          if (!src && !a.dataset.b5Look) {
            a.dataset.b5Look = '1';
            fetch(a.getAttribute('href'), { credentials: 'same-origin' })
              .then(function (r) { return r.ok ? r.text() : ''; })
              .then(function (html) {
                if (!html) return;
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var scope = doc.querySelector('#MainContent, main, [role="main"]') || doc.body;
                var found = '';
                scope.querySelectorAll('img').forEach(function (im) {
                  if (found || im.closest('header, .blt-header, footer, .blt-drawer, [data-b5-nm]')) return;
                  var u = im.getAttribute('src') || im.getAttribute('data-src') || '';
                  if (!u && im.getAttribute('srcset')) u = im.getAttribute('srcset').split(',')[0].trim().split(' ')[0];
                  if (!u || /logo|icon|placeholder|\.svg|data:image/i.test(u)) return;
                  found = u;
                });
                if (!found) return;
                if (found.indexOf('//') === 0) found = 'https:' + found;
                found = found.replace(/([?&])width=\d+/, '$1width=760');
                if (found.indexOf('width=') < 0 && /cdn\.shopify|\/cdn\/shop\//.test(found)) found += (found.indexOf('?') > -1 ? '&' : '?') + 'width=760';
                a.setAttribute('data-b5-img', found);
                a.setAttribute('data-b5-fit', '1');
                if (a.classList.contains('is-hover')) { img.src = found; img.hidden = false; media.classList.add('b5-nm__media--fit'); }
              })
              .catch(function () {});
          }
          if (cap) cap.textContent = 'Shop ' + a.getAttribute('data-b5-label');
          media.setAttribute('href', a.getAttribute('href'));
        });
      });
      nm.addEventListener('mouseleave', function () {
        media.classList.remove('b5-nm__media--fit');
        if (defSrc) { img.src = defSrc; } else { img.hidden = true; }
        if (cap) cap.textContent = defCap;
        media.setAttribute('href', defHref);
        nm.querySelectorAll('.is-hover').forEach(function (x) { x.classList.remove('is-hover'); });
      });
    });
  }

  /* ---- "Chat now" opens Zoho SalesIQ, falls back to contact page ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-b5-chat]');
    if (!b) return;
    try {
      if (window.$zoho && $zoho.salesiq && $zoho.salesiq.floatwindow) { $zoho.salesiq.floatwindow.visible('show'); return; }
    } catch (err) {}
    window.location.href = '/pages/contact-us';
  });

  ready(function () { initHero(); initTabs(); initNavMega(); });
  document.addEventListener('shopify:section:load', function (e) { initHero(e.target); initTabs(e.target); initNavMega(); });
})();


/* collection grid / list view toggle — every page opens in GRID view (all screens);
   the list button switches only the page you are on */
(function () {
  var KEY = 'b5-collection-view';
  try { localStorage.removeItem(KEY); } catch (e) {}          /* forget the old "remember list" choice */
  document.documentElement.classList.remove('b5-list-view');
  function mark() {
    var list = document.documentElement.classList.contains('b5-list-view');
    document.querySelectorAll('[data-b5-view]').forEach(function (b) { b.setAttribute('aria-pressed', String((b.getAttribute('data-b5-view') === 'list') === list)); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-b5-view]');
    if (!b) return;
    document.documentElement.classList.toggle('b5-list-view', b.getAttribute('data-b5-view') === 'list');
    mark();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark); else mark();
})();


/* card quantity selector + Add to cart (collections, homepage, related, accessories) */
(function () {
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function norm(input) {
    var min = parseInt(input.min, 10) || 1, step = parseInt(input.step, 10) || 1;
    var v = parseInt(input.value, 10) || min;
    if (v < min) v = min;
    v = Math.ceil(v / step) * step;
    input.value = v;
    return v;
  }
  function refreshHeader(cart) {
    document.querySelectorAll('.blt-cart-btn__total').forEach(function (el) { el.textContent = money(cart.total_price); });
    document.querySelectorAll('.blt-cart-btn').forEach(function (btn) {
      var icon = btn.querySelector('.blt-cart-btn__icon'); if (!icon) return;
      var b = icon.querySelector('.blt-cart-btn__badge');
      if (!b) { b = document.createElement('span'); b.className = 'blt-cart-btn__badge'; icon.appendChild(b); }
      b.textContent = cart.item_count;
    });
    document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function (el) { el.textContent = cart.item_count; });
  }
  function msg(form, text, ok) {
    var m = form.querySelector('[data-b5-msg]'); if (!m) return;
    m.hidden = !text; m.textContent = text || ''; m.classList.toggle('is-error', !ok);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-b5-step]'); if (!b) return;
    e.preventDefault();
    var form = b.closest('[data-b5-buy]'); var input = form.querySelector('[data-b5-qty]');
    var step = parseInt(input.step, 10) || 1, min = parseInt(input.min, 10) || 1;
    var v = norm(input) + step * parseInt(b.getAttribute('data-b5-step'), 10);
    input.value = v < min ? min : v;
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-b5-qty]')) { norm(e.target); return; }
    if (!e.target.matches('[data-b5-pack]')) return;
    var form = e.target.closest('[data-b5-buy]'), o = e.target.selectedOptions[0];
    var min = parseInt(o.getAttribute('data-min'), 10) || 1, ok = o.getAttribute('data-ok') === '1';
    var input = form.querySelector('[data-b5-qty]');
    form.querySelector('[data-b5-vid]').value = o.value;
    input.min = min; input.step = min; input.value = min;
    var add = form.querySelector('[data-b5-add]'); add.disabled = !ok;
    form.querySelector('[data-b5-add-label]').textContent = ok ? 'Add to cart' : 'Sold out';
    var mb = form.querySelector('[data-b5-min]'); mb.hidden = min < 2;
    form.querySelector('[data-b5-min-n]').textContent = min; form.querySelector('[data-b5-min-s]').textContent = min;
    msg(form, '');
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-b5-buy]'); if (!form) return;
    e.preventDefault();
    var add = form.querySelector('[data-b5-add]'); if (add.disabled) return;
    var qty = norm(form.querySelector('[data-b5-qty]'));
    var id = form.querySelector('[data-b5-vid]').value;
    var label = form.querySelector('[data-b5-add-label]');
    add.disabled = true; add.classList.add('is-loading'); label.textContent = 'Adding…'; msg(form, '');
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: qty }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
        label.textContent = 'Added ✓'; add.classList.add('is-added');
        msg(form, qty + ' added to cart. ', true);
        var m = form.querySelector('[data-b5-msg]');
        if (m) { var a = document.createElement('a'); a.href = '/cart'; a.textContent = 'View cart'; m.appendChild(a); }
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(refreshHeader);
      })
      .catch(function (err) { label.textContent = 'Add to cart'; msg(form, err.message, false); })
      .finally(function () {
        add.classList.remove('is-loading');
        setTimeout(function () { add.disabled = false; add.classList.remove('is-added'); if (label.textContent.indexOf('Added') === 0) label.textContent = 'Add to cart'; }, 2200);
      });
  });
})();

/* load renamed collections (old links in page text) — Shopify follows its own URL redirects */
(function () {
  function get(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) return '';
      /* the redirect can drop ?view=… — ask the new address again with the view */
      var view = (url.split('view=')[1] || '').split('&')[0];
      if (r.redirected && view && r.url.indexOf('view=') === -1) {
        var u = r.url.split('#')[0];
        return fetch(u + (u.indexOf('?') > -1 ? '&' : '?') + 'view=' + view, { credentials: 'same-origin' })
          .then(function (r2) { return r2.ok ? r2.text() : ''; });
      }
      return r.text();
    });
  }
  function run(scope) {
    var seen = {};
    document.querySelectorAll('[data-b5-handle]').forEach(function (a) { seen[a.getAttribute('data-b5-handle')] = 1; });
    (scope || document).querySelectorAll('[data-b5-load]').forEach(function (ph) {
      var url = ph.getAttribute('data-b5-load'); ph.removeAttribute('data-b5-load');
      get(url).then(function (html) {
        html = (html || '').trim();
        /* only accept our small card / tile markup, never a full page */
        if (!html || html.charAt(0) !== '<' || html.indexOf('<html') > -1 || html.length > 20000) { ph.remove(); return; }
        var t = document.createElement('template'); t.innerHTML = html;
        var el = t.content.firstElementChild;
        if (!el || !/b5-cat|b5-brands__tile/.test(el.className)) { ph.remove(); return; }
        var h = el.getAttribute('data-b5-handle') || el.getAttribute('href');
        var cur = (location.pathname.split('/collections/')[1] || '').split('/')[0];
        if (cur && el.getAttribute('data-b5-handle') === cur) el.classList.add('is-active');
        else if (h && seen[h]) { ph.remove(); return; }
        if (h) seen[h] = 1;
        ph.replaceWith(el);
      }).catch(function () { ph.remove(); });
    });
  }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', function () { run(); });
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  new MutationObserver(function () { if (document.querySelector('[data-b5-load]')) run(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
/* b5 collection-card pack selector (same-SKU products: Pack of 6 / 10 / 20 …).
   Swaps price, buy form, links, title, SKU and image on the card. */
(function () {
  document.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-b5-packopt]');
    if (!opt) return;
    e.preventDefault();
    var card = opt.closest('.card-wrapper') || opt.closest('.card');
    if (!card || opt.classList.contains('is-active')) return;
    var id = opt.getAttribute('data-b5-packopt');
    var tpl = card.querySelector('template[data-b5-packtpl="' + id + '"]');
    if (!tpl) return;
    var frag = tpl.content.cloneNode(true);
    var newPrice = frag.querySelector('[data-part="price"]');
    var newBuy = frag.querySelector('[data-part="buy"]');

    /* price */
    var oldPrice = card.querySelector('.card__information .b5-price');
    if (oldPrice && newPrice) {
      var np = newPrice.firstElementChild;
      if (np) oldPrice.replaceWith(np);
    }
    /* buy form (or quote link) */
    var buyBox = card.querySelector('.b5-card__buy');
    if (buyBox && newBuy) {
      [].slice.call(buyBox.children).forEach(function (el) {
        if (el.matches('[data-b5-buy], .b5-buy__quote')) el.remove();
      });
      var more = buyBox.querySelector('.b5-card__more');
      [].slice.call(newBuy.childNodes).forEach(function (n) { buyBox.insertBefore(n, more); });
    }
    /* links + title */
    var url = opt.getAttribute('data-url'), title = opt.getAttribute('data-title');
    card.querySelectorAll('.card__heading a, a.b5-card__more, .card__media a, a.full-unstyled-link, a.b5-card-titlebar__link').forEach(function (a) {
      a.setAttribute('href', url);
      if (a.closest('.card__heading') || a.classList.contains('b5-card-titlebar__link')) a.textContent = title;
      if (a.classList.contains('b5-card-titlebar__link')) a.title = title;
    });
    /* sku */
    var sku = card.querySelector('.b5-card__sku');
    if (sku) sku.textContent = 'SKU: ' + (opt.getAttribute('data-sku') || '');
    /* image */
    var img = card.querySelector('.card__media img');
    if (img && opt.getAttribute('data-img')) {
      img.removeAttribute('srcset');
      img.src = opt.getAttribute('data-img');
      if (opt.getAttribute('data-srcset')) img.srcset = opt.getAttribute('data-srcset');
    }
    /* pills */
    opt.parentNode.querySelectorAll('[data-b5-packopt]').forEach(function (b) {
      var on = b === opt;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  });
})();

/* ---------- b5 reorder: order history + order detail ([data-b5-reorder]) ---------- */
(function () {
  function wrap(el) { return el && el.closest('[data-b5-reorder]'); }
  function sync(w) {
    var boxes = w.querySelectorAll('[data-b5-ro-chk]');
    var on = w.querySelectorAll('[data-b5-ro-chk]:checked').length;
    var all = w.querySelector('[data-b5-ro-all]');
    var cnt = w.querySelector('[data-b5-ro-count]');
    var btn = w.querySelector('[data-b5-ro-add]');
    if (all) { all.checked = boxes.length > 0 && on === boxes.length; all.indeterminate = on > 0 && on < boxes.length; all.disabled = !boxes.length; }
    if (cnt) cnt.textContent = on + (on === 1 ? ' item selected' : ' items selected');
    if (btn) btn.disabled = on === 0;
  }
  function msg(w, text, ok) {
    var m = w.querySelector('[data-b5-ro-msg]');
    if (!m) return;
    m.textContent = text || '';
    m.className = 'b5ac-ro__msg' + (text ? (ok ? ' is-ok' : ' is-err') : '');
  }
  document.addEventListener('change', function (e) {
    var t = e.target, w = wrap(t);
    if (!w) return;
    if (t.matches('[data-b5-ro-all]')) {
      w.querySelectorAll('[data-b5-ro-chk]').forEach(function (c) { c.checked = t.checked; });
    }
    if (t.matches('[data-b5-ro-qty]')) {
      var c = t.closest('[data-b5-ro-item]').querySelector('[data-b5-ro-chk]');
      if (c && parseInt(t.value, 10) > 0) c.checked = true;
    }
    msg(w, '');
    sync(w);
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-b5-ro-add]');
    if (!btn) return;
    var w = wrap(btn);
    if (!w) return;
    e.preventDefault();
    var map = {};
    w.querySelectorAll('[data-b5-ro-chk]:checked').forEach(function (c) {
      var q = c.closest('[data-b5-ro-item]').querySelector('[data-b5-ro-qty]');
      var min = parseInt(q && q.min, 10) || 1;
      var n = parseInt(q && q.value, 10) || 0;
      if (n < min) n = min;
      if (q && String(q.value) !== String(n)) q.value = n;
      map[c.value] = (map[c.value] || 0) + n; /* same product in two orders = one cart line */
    });
    var items = Object.keys(map).map(function (id) { return { id: parseInt(id, 10), quantity: map[id] }; });
    if (!items.length) { msg(w, 'Select at least one item to add to cart.'); return; }
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.d && (res.d.description || res.d.message)) || 'Could not add these items to the cart.');
        msg(w, 'Added to cart — taking you to your cart…', true);
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      })
      .catch(function (err) {
        msg(w, err.message);
        btn.disabled = false;
        btn.textContent = label;
      });
  });
  function init() { document.querySelectorAll('[data-b5-reorder]').forEach(sync); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ---------- b5 header cart sync: badge + total update after ANY cart change (cart page, product page, quick add, quick order) ---------- */
(function () {
  if (window.__b5CartSync) return;
  window.__b5CartSync = true;
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var timer = null;
  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function paint(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;
    document.querySelectorAll('.blt-cart-btn').forEach(function (btn) {
      var icon = btn.querySelector('.blt-cart-btn__icon');
      var badge = btn.querySelector('.blt-cart-btn__badge');
      if (cart.item_count > 0) {
        if (!badge && icon) { badge = document.createElement('span'); badge.className = 'blt-cart-btn__badge'; icon.appendChild(badge); }
        if (badge) { badge.textContent = cart.item_count; badge.hidden = false; }
      } else if (badge) {
        badge.remove();
      }
      btn.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's'));
    });
    document.querySelectorAll('.blt-cart-btn__total').forEach(function (el) { el.textContent = money(cart.total_price); });
    document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function (el) { el.textContent = cart.item_count; });
  }
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      _fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(paint).catch(function () {});
    }, 150);
  }
  window.b5RefreshCart = refresh;
  /* watch fetch() */
  var _fetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch(input, init);
    if (CART_RE.test(url)) p.then(function () { refresh(); }).catch(function () {});
    return p;
  };
  /* watch XMLHttpRequest (jQuery / older scripts) */
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    this.__b5cart = CART_RE.test(String(url || ''));
    return _open.apply(this, arguments);
  };
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__b5cart) this.addEventListener('loadend', refresh);
    return _send.apply(this, arguments);
  };
  /* theme pub/sub + page restored from back/forward cache */
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:refresh', refresh);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
    try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refresh); } catch (e) {}
  }
})();

/* ---------- b5 contact form: always say "thank you" after sending (even if Shopify sends the visitor back to the home page) ---------- */
(function () {
  function run() {
    if (!/[?&]contact_posted=true/.test(location.search)) return;
    if (document.querySelector('.b5ct__alert--ok, .form-success, .form__message[role="status"], .contact .form-status')) return;
    var box = document.createElement('div');
    box.className = 'b5-thanks';
    box.setAttribute('role', 'status');
    box.innerHTML = '<div class="b5-thanks__card"><span class="b5-thanks__ico" aria-hidden="true">&#10003;</span><strong>Thank you for contacting us!</strong><p>Your message has been sent. Our team will get back to you within one business day.</p><button type="button" class="b5-thanks__btn">Close</button></div>';
    document.body.appendChild(box);
    function close() { box.remove(); if (history.replaceState) history.replaceState(null, '', location.pathname); }
    box.addEventListener('click', function (e) { if (e.target === box || e.target.closest('.b5-thanks__btn')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* ---------- b5 spec table: hide rows that have no value (blank / NA) so the table has no empty lines ---------- */
(function () {
  function run() {
    document.querySelectorAll('.spec-table tr').forEach(function (tr) {
      var cells = tr.querySelectorAll('td');
      if (cells.length < 2) return;
      var v = (cells[cells.length - 1].textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
      if (v === '' || v === 'NA' || v === 'N/A' || v === '-' || v === '—') tr.remove();
    });
    document.querySelectorAll('.main-product-new-style .feature-badges > span').forEach(function (sp) {
      var st = sp.querySelector('strong');
      var v = st ? (st.textContent || '').trim().toUpperCase() : '';
      if (v === '' || v === 'NA' || v === 'N/A') sp.remove();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* ---------- b5 "All …" collection view: filters (series, availability, wattage, CCT, price) + sort, no page reload ---------- */
(function () {
  function money(t) { var m = String(t || '').replace(/,/g, '').match(/(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : NaN; }
  function tokens(str, re) {
    var out = [];
    String(str || '').toUpperCase().split(/[\/,|;]+|\s+/).forEach(function (t) { t = t.trim(); if (re.test(t) && out.indexOf(t) < 0) out.push(t); });
    return out;
  }
  function init(root) {
    if (root.dataset.b5fReady) return;
    root.dataset.b5fReady = '1';
    var grid = root.querySelector('[data-b5f-grid]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-b5f-item]'));
    var countEl = root.querySelector('[data-b5f-count]');
    var emptyEl = root.querySelector('[data-b5f-empty]');
    var minEl = root.querySelector('[data-b5f-min]'), maxEl = root.querySelector('[data-b5f-max]');
    var sortEl = root.querySelector('[data-b5f-sort]');
    items.forEach(function (li) {
      var p = li.querySelector('.b5-price__now, .tier-price, .price-item--regular');
      li._price = p ? money(p.textContent) : NaN;
      li._watt = tokens(li.getAttribute('data-watt'), /^\d+(\.\d+)?W$/);
      li._cct = tokens(li.getAttribute('data-cct'), /^\d+(\.\d+)?K$/);
    });
    /* build Wattage / CCT option lists from the products */
    [['watt', '_watt'], ['cct', '_cct']].forEach(function (d) {
      var box = root.querySelector('[data-b5f-dyn="' + d[0] + '"]');
      if (!box) return;
      var vals = [];
      items.forEach(function (li) { li[d[1]].forEach(function (v) { if (vals.indexOf(v) < 0) vals.push(v); }); });
      if (vals.length < 2) return;
      vals.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
      var opts = box.querySelector('.b5f__opts');
      vals.forEach(function (v) {
        var l = document.createElement('label'); l.className = 'b5f__opt';
        l.innerHTML = '<input type="checkbox" data-b5f-key="' + d[0] + '" value="' + v + '"><span>' + v + '</span><em data-b5f-n></em>';
        opts.appendChild(l);
      });
      box.hidden = false;
    });
    function sel(key) {
      return Array.prototype.slice.call(root.querySelectorAll('[data-b5f-key="' + key + '"]:checked')).map(function (i) { return i.value; });
    }
    function match(li, f, skip) {
      if (skip !== 'series' && f.series.length && f.series.indexOf(li.getAttribute('data-series')) < 0) return false;
      if (skip !== 'avail' && f.avail.length && f.avail.indexOf(li.getAttribute('data-avail')) < 0) return false;
      if (skip !== 'watt' && f.watt.length && !li._watt.some(function (v) { return f.watt.indexOf(v) > -1; })) return false;
      if (skip !== 'cct' && f.cct.length && !li._cct.some(function (v) { return f.cct.indexOf(v) > -1; })) return false;
      if (!isNaN(f.min) && !(li._price >= f.min)) return false;
      if (!isNaN(f.max) && !(li._price <= f.max)) return false;
      return true;
    }
    function apply() {
      var f = { series: sel('series'), avail: sel('avail'), watt: sel('watt'), cct: sel('cct'), min: parseFloat(minEl && minEl.value), max: parseFloat(maxEl && maxEl.value) };
      var shown = 0;
      items.forEach(function (li) { var ok = match(li, f); li.hidden = !ok; if (ok) shown++; });
      /* counts next to each option (what you would get if you ticked it) */
      root.querySelectorAll('[data-b5f-key]').forEach(function (inp) {
        var key = inp.getAttribute('data-b5f-key'), v = inp.value, n = 0;
        items.forEach(function (li) {
          if (!match(li, f, key)) return;
          var has = key === 'series' ? li.getAttribute('data-series') === v : key === 'avail' ? li.getAttribute('data-avail') === v : li['_' + key].indexOf(v) > -1;
          if (has) n++;
        });
        var em = inp.parentNode.querySelector('[data-b5f-n]');
        if (em) em.textContent = '(' + n + ')';
        inp.parentNode.classList.toggle('is-zero', n === 0 && !inp.checked);
      });
      var active = f.series.length + f.avail.length + f.watt.length + f.cct.length + (isNaN(f.min) ? 0 : 1) + (isNaN(f.max) ? 0 : 1);
      root.querySelectorAll('[data-b5f-clear]').forEach(function (b) { if (!b.classList.contains('b5f__clear--btn')) b.hidden = !active; });
      var badge = root.querySelector('[data-b5f-active]'); if (badge) badge.textContent = active ? '(' + active + ')' : '';
      if (countEl) countEl.textContent = shown + (shown === 1 ? ' product' : ' products');
      if (emptyEl) emptyEl.hidden = shown > 0;
    }
    function sort() {
      var v = sortEl ? sortEl.value : 'featured';
      var arr = items.slice();
      arr.sort(function (a, b) {
        if (v === 'price-asc' || v === 'price-desc') {
          var pa = isNaN(a._price) ? Infinity : a._price, pb = isNaN(b._price) ? Infinity : b._price;
          return v === 'price-asc' ? pa - pb : (pb === Infinity ? -1 : pa === Infinity ? 1 : pb - pa);
        }
        if (v === 'az' || v === 'za') { var c = a.getAttribute('data-title').localeCompare(b.getAttribute('data-title')); return v === 'az' ? c : -c; }
        return a.getAttribute('data-i') - b.getAttribute('data-i');
      });
      arr.forEach(function (li) { grid.appendChild(li); });
    }
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-b5f-sort]')) sort(); else apply();
    });
    root.addEventListener('input', function (e) { if (e.target.matches('[data-b5f-min], [data-b5f-max]')) apply(); });
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-b5f-toggle]');
      if (t) { var open = root.classList.toggle('is-open'); t.setAttribute('aria-expanded', open); return; }
      if (e.target.closest('[data-b5f-clear]')) {
        root.querySelectorAll('[data-b5f-key]:checked').forEach(function (i) { i.checked = false; });
        if (minEl) minEl.value = ''; if (maxEl) maxEl.value = '';
        apply();
      }
    });
    apply();
  }
  /* series whose brand-page link is an old (renamed) collection: load their cards first, then start the filters */
  function loadOld(root) {
    var old = (root.getAttribute('data-b5f-old') || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    if (!old.length) return Promise.resolve();
    var grid = root.querySelector('[data-b5f-grid]');
    var seriesBox = root.querySelector('[data-b5f-key="series"]');
    seriesBox = seriesBox ? seriesBox.closest('.b5f__opts') : null;
    root.classList.add('is-loading');
    return Promise.all(old.map(function (h) {
      return fetch('/collections/' + encodeURIComponent(h) + '?view=b5cards', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (pages) {
      var n = grid.querySelectorAll('[data-b5f-item]').length;
      pages.forEach(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var wrap = doc.querySelector('[data-b5cards]');
        if (!wrap) return;
        var handle = wrap.getAttribute('data-handle');
        var added = 0;
        wrap.querySelectorAll('[data-b5f-item]').forEach(function (li) {
          var key = li.getAttribute('data-key');
          if (key && grid.querySelector('[data-b5f-item][data-key="' + key.replace(/"/g, '\\"') + '"]')) return;
          li.setAttribute('data-i', ++n);
          grid.appendChild(document.importNode(li, true));
          added++;
        });
        if (added && seriesBox && !root.querySelector('[data-b5f-key="series"][value="' + handle + '"]')) {
          var l = document.createElement('label'); l.className = 'b5f__opt';
          l.innerHTML = '<input type="checkbox" data-b5f-key="series" value="' + handle + '"><span></span><em data-b5f-n></em>';
          l.querySelector('span').textContent = wrap.getAttribute('data-title') || handle;
          seriesBox.appendChild(l);
        }
      });
    }).then(function () { root.classList.remove('is-loading'); });
  }
  function run() {
    document.querySelectorAll('[data-b5f]').forEach(function (root) {
      loadOld(root).then(function () { init(root); }, function () { init(root); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Indoor / Outdoor / Signage dropdown: run from the menu item to the end of Contact Us (min 720px), always inside the screen */
(function () {
  function fit(li) {
    var p = li.querySelector(':scope > .b5-nm__panel');
    if (!p || window.innerWidth < 1025) return;
    var menu = li.parentElement, last = menu.lastElementChild;
    var r = li.getBoundingClientRect(), end = last ? last.getBoundingClientRect().right : r.right;
    var w = (window.innerWidth <= 1200 ? 600 : 680), vw = window.innerWidth; /* b5: Indoor / Outdoor / Signage all the same width */
    w = Math.min(w, vw - 32);
    p.style.setProperty('--b5-nm-w', w + 'px');
    var over = r.left + w - (vw - 16);
    p.style.setProperty('--b5-nm-shift', over > 0 ? (-Math.min(over, r.left - 16)) + 'px' : '0px');
  }
  function bind() {
    document.querySelectorAll('.blt-menu > .b5-nm').forEach(function (li) {
      if (li.dataset.b5Fit) return; li.dataset.b5Fit = '1';
      li.addEventListener('mouseenter', function () { fit(li); });
      li.addEventListener('focusin', function () { fit(li); });
      fit(li);
    });
  }
  if (document.readyState !== 'loading') bind(); else document.addEventListener('DOMContentLoaded', bind);
  window.addEventListener('resize', function () { document.querySelectorAll('.blt-menu > .b5-nm').forEach(fit); });
  document.addEventListener('shopify:section:load', bind);
})();

/* Menu pictures: wide room photos fill the box; square-ish product photos are shown whole on white (never cut) */
(function () {
  function decide(img) {
    var media = img.closest('[data-b5-media]');
    if (!media || !img.complete || !img.naturalWidth) return;
    var r = img.naturalWidth / img.naturalHeight;
    media.classList.toggle('b5-nm__media--fit', r > 0.6 && r < 1.3);
  }
  function bind() {
    document.querySelectorAll('[data-b5-media-img]').forEach(function (img) {
      if (img.dataset.b5Ratio) return; img.dataset.b5Ratio = '1';
      img.addEventListener('load', function () { decide(img); });
      new MutationObserver(function () { setTimeout(function () { decide(img); }, 0); }).observe(img, { attributes: true, attributeFilter: ['src'] });
      decide(img);
    });
  }
  if (document.readyState !== 'loading') bind(); else document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
})();

/* Series / category cards: show the full text on hover when an info line is cut with "…" */
(function () {
  function tip(root) {
    (root || document).querySelectorAll('.b5-cat__feats li, .b5-late-info li, .b5-specs--icons dd').forEach(function (li) {
      if (!li.title) li.title = li.textContent.replace(/\s+/g, ' ').trim();
    });
  }
  if (document.readyState !== 'loading') tip(); else document.addEventListener('DOMContentLoaded', function () { tip(); });
  new MutationObserver(function () { tip(); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Request a Quote pop-up: always opens centred on the screen (moved to <body> so no page section can push it
   over the product images), fits any screen, scroll locked behind it, closes on Esc / outside click */
(function () {
  function prep() {
    document.querySelectorAll('.modals').forEach(function (m) {
      if (m.parentElement !== document.body) document.body.appendChild(m);
      if (m.dataset.b5Modal) return; m.dataset.b5Modal = '1';
      m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true');
      m.addEventListener('click', function (e) { if (e.target === m) hide(m); });
      new MutationObserver(function () {
        var open = m.style.display && m.style.display !== 'none';
        document.documentElement.classList.toggle('b5-modal-open', !!document.querySelector('.modals[style*="block"], .modals[style*="flex"]'));
        if (open && m.style.display !== 'flex') m.style.display = 'flex';
      }).observe(m, { attributes: true, attributeFilter: ['style'] });
    });
  }
  function hide(m) { m.style.display = 'none'; }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.modals').forEach(function (m) { if (m.style.display && m.style.display !== 'none') hide(m); });
  });
  if (document.readyState !== 'loading') prep(); else document.addEventListener('DOMContentLoaded', prep);
  document.addEventListener('shopify:section:load', prep);
})();

/* Product photos: previous / next arrows + "1 / 8" counter on the main picture (uses the existing thumbnail clicks, so
   pack switching and zoom keep working); swipe on phones; keeps the active thumbnail in view */
(function () {
  function init() {
    document.querySelectorAll('.main-product-new-style .product-gallery').forEach(function (g) {
      if (g.dataset.b5Gal) return; g.dataset.b5Gal = '1';
      var main = g.querySelector('.gallery-main'); if (!main) return;
      function thumbs() { return Array.prototype.slice.call(g.querySelectorAll('.thumb-item')); }
      if (thumbs().length < 2) return;
      var arrow = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg>'; };
      var prev = document.createElement('button'); prev.type = 'button'; prev.className = 'b5-gal__nav b5-gal__nav--prev'; prev.setAttribute('aria-label', 'Previous image'); prev.innerHTML = arrow('M15 18l-6-6 6-6');
      var next = document.createElement('button'); next.type = 'button'; next.className = 'b5-gal__nav b5-gal__nav--next'; next.setAttribute('aria-label', 'Next image'); next.innerHTML = arrow('M9 6l6 6-6 6');
      var count = document.createElement('span'); count.className = 'b5-gal__count'; count.setAttribute('aria-live', 'polite');
      main.appendChild(prev); main.appendChild(next); main.appendChild(count);
      function idx() { var t = thumbs(); for (var i = 0; i < t.length; i++) if (t[i].classList.contains('active')) return i; return 0; }
      function update() {
        var t = thumbs(), i = idx(); count.textContent = (i + 1) + ' / ' + t.length;
        var a = t[i], strip = a && a.parentElement;
        if (strip && strip.scrollWidth > strip.clientWidth) {
          var l = a.offsetLeft - strip.offsetLeft, r = l + a.offsetWidth;
          if (l < strip.scrollLeft || r > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = l - (strip.clientWidth - a.offsetWidth) / 2;
        }
      }
      function go(step) { var t = thumbs(); if (!t.length) return; var n = (idx() + step + t.length) % t.length; t[n].click(); setTimeout(update, 0); }
      prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
      next.addEventListener('click', function (e) { e.preventDefault(); go(1); });
      var x0 = null;
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1); x0 = null; });
      new MutationObserver(update).observe(g, { subtree: true, attributes: true, attributeFilter: ['class'] });
      update();
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

/* Recommended Accessories / You May Also Like: under the product photos on desktop (990px+), back in the right column on tablet/mobile */
(function () {
  var mq = window.matchMedia('(min-width: 990px)');
  function place() {
    document.querySelectorAll('.main-product-new-style').forEach(function (sec) {
      var block = sec.querySelector('[data-upsell-block]'), gal = sec.querySelector('.product-gallery'), info = sec.querySelector('.product-info');
      if (!block || !gal || !info) return;
      if (!block.b5Home) { block.b5Home = { parent: block.parentNode, next: block.nextSibling }; }
      if (mq.matches) { if (block.parentNode !== gal) gal.appendChild(block); }
      else if (block.parentNode !== block.b5Home.parent) {
        var h = block.b5Home; if (h.next && h.next.parentNode === h.parent) h.parent.insertBefore(block, h.next); else h.parent.appendChild(block);
      }
    });
  }
  if (document.readyState !== 'loading') place(); else document.addEventListener('DOMContentLoaded', place);
  if (mq.addEventListener) mq.addEventListener('change', place); else mq.addListener(place);
  document.addEventListener('shopify:section:load', place);
})();

/* Collection pages: "N products / Sort by" bar sits in the right column, level with "Filter:" — same layout as the "All …" view.
   The bar and product grid are wrapped together (the grid itself is still refreshed by Shopify's filters as before). */
(function () {
  function layout() {
    var sort = document.querySelector('facet-filters-form.facets-vertical-sort');
    var grid = document.getElementById('ProductGridContainer');
    if (!sort || !grid) return;
    var row = grid.parentElement;
    if (!row || !row.classList.contains('facets-vertical') || !row.querySelector(':scope > .facets-wrapper')) return;
    if (grid.parentElement.classList.contains('b5-colmain')) return;
    var col = document.createElement('div'); col.className = 'b5-colmain';
    row.insertBefore(col, grid); col.appendChild(sort); col.appendChild(grid);
    document.documentElement.classList.add('b5-coll-2col');
  }
  if (document.readyState !== 'loading') layout(); else document.addEventListener('DOMContentLoaded', layout);
  document.addEventListener('shopify:section:load', layout);
})();

/* Product page: price + trade-partner box (or shipping info for logged-in partners) grouped as one left column next to
   Key Specifications, so both columns always end on the same line */
(function () {
  function group() {
    document.querySelectorAll('.main-product-new-style .product-info').forEach(function (info) {
      if (info.querySelector(':scope > .b5-pricecol')) return;
      var price = info.querySelector(':scope > .price-wrapper'), specs = info.querySelector(':scope > .feature-badges');
      if (!price || !specs || !specs.querySelector('span')) return;
      var extra = info.querySelector(':scope > .trade-pricing-box') || info.querySelector(':scope > .shipping-benefits');
      var col = document.createElement('div'); col.className = 'b5-pricecol';
      info.insertBefore(col, price); col.appendChild(price); if (extra) { col.appendChild(extra); extra.classList.add('b5-pricecol__extra'); }
      info.classList.add('b5-has-pricecol');
    });
  }
  if (document.readyState !== 'loading') group(); else document.addEventListener('DOMContentLoaded', group);
  document.addEventListener('shopify:section:load', group);
})();

/* Series tiles: hide any series whose collection has no products (renamed collections can't be counted in the theme code,
   so they are checked here with one small request each, remembered for the visit) */
(function () {
  function check() {
    document.querySelectorAll('.b5-brands__tile[data-b5-old]').forEach(function (tile) {
      if (tile.dataset.b5Checked) return; tile.dataset.b5Checked = '1';
      var h = tile.getAttribute('data-b5-old'), key = 'b5cnt:' + h, n = null;
      try { n = sessionStorage.getItem(key); } catch (e) {}
      function apply(cnt) { if (+cnt === 0 && !tile.classList.contains('is-active')) tile.remove(); else if (+cnt === 0) tile.classList.add('b5-brands__tile--empty'); }
      if (n !== null) { apply(n); return; }
      fetch('/collections/' + encodeURIComponent(h) + '?view=b5cards', { credentials: 'same-origin' })
        .then(function (r) {
          var u = new URL(r.url, location.href);
          /* gone, or redirected off this store / away from a collection: treat as empty */
          if (!r.ok || u.origin !== location.origin || u.pathname.indexOf('/collections/') === -1) return 'DEAD';
          return r.text();
        })
        .then(function (html) {
          if (html === 'DEAD') { apply(0); return; }
          if (!html || html.indexOf('data-b5cards') === -1) return; /* could not check — leave the tile */
          var cnt = (html.match(/data-b5f-item/g) || []).length;
          try { sessionStorage.setItem(key, String(cnt)); } catch (e) {}
          apply(cnt);
        }).catch(function () { apply(0); }); /* fetch blocked = redirected to another site */
    });
  }
  if (document.readyState !== 'loading') check(); else document.addEventListener('DOMContentLoaded', check);
  document.addEventListener('shopify:section:load', check);
})();

/* Indoor / Outdoor / Signage dropdowns: same HEIGHT as the Shop by Category mega menu (width unchanged).
   Shop by Category's real height is measured (it changes with its content and the screen) and copied to the three panels. */
(function () {
  var raf = 0;
  function sync() {
    raf = 0;
    var root = document.documentElement;
    if (window.innerWidth < 1025) { root.style.removeProperty('--b5-cat-h'); return; }
    var cat = document.querySelector('.blt-menu > .blt-cat > .blt-mega') || document.querySelector('.blt-cat .blt-mega');
    if (!cat) return;
    /* both menus get the same height: Shop by Category's content height, but never past the bottom of the screen */
    var top = cat.getBoundingClientRect().top;
    var avail = Math.max(260, Math.round(window.innerHeight - top - 16));
    var h = Math.min(Math.round(cat.scrollHeight), avail);
    if (h > 120) { root.style.setProperty('--b5-cat-h', h + 'px'); root.style.setProperty('--b5-dd-max', avail + 'px'); }
  }
  function queue() { if (!raf) raf = requestAnimationFrame(sync); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queue); else queue();
  window.addEventListener('load', queue);
  window.addEventListener('resize', queue);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
  document.addEventListener('mouseover', function (e) { if (e.target.closest && e.target.closest('.blt-menu > .b5-nm, .blt-menu > .blt-cat')) sync(); });
  document.addEventListener('focusin', function (e) { if (e.target.closest && e.target.closest('.blt-menu > .b5-nm')) sync(); });
})();

/* Product cards (collection, search, home, recommended, recently viewed): the WHOLE card opens the product —
   photo, title bar, specs, price, empty space. Buttons, quantity, pack sizes and links keep working as before. */
(function () {
  var CARD = '.product-grid .card-wrapper, .blt-prods__card';
  var SKIP = 'a, button, input, select, textarea, label, form, [role="button"], [data-b5-packopt], .b5-pack, .b5-card__buy, .b5-buy, .blt-prods__wish, .quick-add';
  function urlOf(card) {
    var a = card.querySelector('a.b5-card-titlebar__link') || card.querySelector('.card__heading a') || card.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href') : '';
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button > 0) return;
    var card = e.target.closest && e.target.closest(CARD);
    if (!card || e.target.closest(SKIP)) return;
    if (window.getSelection && String(window.getSelection())) return; /* let people select text */
    var url = urlOf(card);
    if (!url) return;
    if (e.ctrlKey || e.metaKey || e.shiftKey) window.open(url, '_blank'); else window.location.href = url;
  });
  document.addEventListener('auxclick', function (e) {
    if (e.button !== 1) return;
    var card = e.target.closest && e.target.closest(CARD);
    if (!card || e.target.closest(SKIP)) return;
    var url = urlOf(card); if (url) window.open(url, '_blank');
  });
})();

/* "All …" series tile with no picture: borrow the picture of the first series tile next to it */
(function () {
  function fill() {
    document.querySelectorAll('.b5-brands').forEach(function (row) {
      var all = row.querySelector('.b5-brands__tile--all .b5-brands__img');
      if (!all || all.querySelector('img')) return;
      var src = null;
      row.querySelectorAll('.b5-brands__tile:not(.b5-brands__tile--all) img').forEach(function (im) { if (!src && (im.currentSrc || im.getAttribute('src'))) src = im; });
      if (!src) return;
      var img = document.createElement('img');
      img.src = src.currentSrc || src.getAttribute('src'); img.alt = ''; img.loading = 'lazy';
      var svg = all.querySelector(':scope > svg'); if (svg) svg.remove();
      all.appendChild(img);
      all.insertAdjacentHTML('beforeend', '<span class="b5-brands__dots" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor"><rect x="3" y="3" width="7.5" height="7.5" rx="2"/><rect x="13.5" y="3" width="7.5" height="7.5" rx="2"/><rect x="3" y="13.5" width="7.5" height="7.5" rx="2"/><rect x="13.5" y="13.5" width="7.5" height="7.5" rx="2"/></svg></span>');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fill); else fill();
  window.addEventListener('load', fill);
})();